import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { formatPrice } from '../utils/currency';

const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return `${process.env.REACT_APP_API_URL}${url}`;
};

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [search,  setSearch]    = useState('');
  const [currency, setCurrency] = useState('MAD');
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/api/products')
      .then(({ data }) => setProducts(data.data))
      .catch(console.error)
      .finally(() => setLoading(false));
    api.get('/api/settings')
      .then(({ data }) => setCurrency(data.data.currency || 'MAD'))
      .catch(() => {});
  }, []);

  const filtered = products.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="page">
      <div className="container">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem', marginBottom: '2rem' }}>
          <h1 className="section-title" style={{ margin: 0 }}>All Products</h1>
          <input
            className="form-control"
            style={{ maxWidth: '260px' }}
            placeholder="Search products…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        {loading ? (
          <div className="loader"><div className="spinner" /></div>
        ) : filtered.length === 0 ? (
          <p style={{ color: 'var(--text-muted)' }}>No products found.</p>
        ) : (
          <div className="product-grid">
            {filtered.map(p => (
              <div
                key={p.id}
                className="card product-card"
                onClick={() => navigate(`/products/${p.id}`)}
              >
                {(p.image_url || (p.images && p.images[0]?.image_url))
                  ? <img className="product-img" src={getImageUrl((p.image_url || (p.images && p.images[0]?.image_url)))} alt={p.name} />
                  : <div className="product-img-placeholder">📦</div>
                }
                <div className="product-info">
                  <h3>{p.name}</h3>
                  <div className="product-price">{formatPrice(p.price, currency)}</div>
                  {p.stock !== null && (
                    <div className="product-stock">
                      {p.stock > 0 ? `${p.stock} in stock` : '⚠️ Out of stock'}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;
